module.exports = __webpack_public_path__ + "assets/img/img133.b24a8535.png";